// Copyright 2022 Amazon.com, Inc. or its affiliates. All Rights Reserved.
export enum AuthConfigurationStatus {
    LOADING = "LOADING",
    CONFIGURED = "CONFIGURED",
}
